export default __webpack_public_path__ + "static/media/circle-o-tick-purple.a7c86e27.svg";